<template>
    <div class="examData-wrapper">
        <div class="top-tab">
            <el-tabs v-model="tabName" class="tabs-full" @tab-click="toggleTab">
                <el-tab-pane label="理论题" name="examCenterExamDataTheory"></el-tab-pane>
<!--                <el-tab-pane label="商品信息采集与处理" name="examCenterExamDataGoodsInfo"></el-tab-pane>-->
<!--                <el-tab-pane label="网店装修" name="examCenterExamDataStoreDecorate"></el-tab-pane>-->
<!--                <el-tab-pane label="网店管理" name="examCenterExamDataStoreManage"></el-tab-pane>-->
<!--                <el-tab-pane label="网络推广" name="examCenterExamDataNetworkPromote"></el-tab-pane>-->
                <el-tab-pane label="网店客户服务" name="examCenterExamDataStoreCustomer"></el-tab-pane>
<!--                <el-tab-pane label="电子商务数据收集与清洗" name="examCenterExamDataECommerceData"></el-tab-pane>-->
            </el-tabs>
            <div class="right">
                <el-button type="primary" @click="goBack">返回</el-button>
            </div>
        </div>
        <div class="container">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                examId: this.$route.query.examId || null,
                studentId:this.$route.query.id || null,
                tabName: 'examCenterExamDataTheory'
            }
        },
        created() {
            this.tabName = this.$route.meta.tabName;
        },
        methods: {
            toggleTab(tab) {
                this.$router.push({
                    name: tab.name,
                    query:{
                      id:this.studentId,
                      examId:this.examId,
                      isGrade:this.$route.query.isGrade
                    }
                })
            },
            goBack() {
                this.$router.push({
                    path: '/examCenter/examData/student',
                    query: {
                        examId: this.examId
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .examData-wrapper {
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        .container {
            height: 1%;
            flex: 1;
            position: relative;
        }
    }
    .top-tab {
        margin: 0 20px;
        display: flex;
        justify-content: space-between;
        position: relative;
        &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 1px;
            background: #F1F5FF;
        }
        .right {
            width: 90px;
            text-align: right;
            margin-top: -5px;
        }
    }
    .tabs-full {
      width: 1%;
      flex: 1;
      ::v-deep {
        .el-tabs__nav-wrap{
          margin-bottom: 0;
        }
        .el-tabs__nav-wrap::after {
          content: none;
        }
        .el-tabs__header {
          margin-bottom: 0;
        }
        .el-tabs__active-bar {
          display: none;
        }
        .el-tabs__item {
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          font-weight: normal;
          text-align: center;
          color: #333;
          background: #F3F6F8;
          border: 1px solid #DDDDDD;
          border-radius: 6px 6px 0 0;
          margin-right: 10px;
          &.is-active {
            color: #F23B2F;
            line-height: 46px;
            text-align: center;
            font-size: 16px;
            border: 1px solid #DDDDDD;
            -webkit-border-radius: 6px 6px 0 0;
            border-radius: 6px 6px 0 0;
            background: #fff;
            border-top: 4px solid;
            border-bottom: none;
          }
        }
        .el-tabs__item.is-top:nth-child(2) {
          padding-left: 20px;
        }
        .el-tabs__item.is-top:last-child {
          padding-right: 20px;
        }
      }
    }
</style>